import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, throwMatDialogContentAlreadyAttachedError } from '@angular/material';
import * as Chart from "chart.js";
@Component({
  selector: 'app-analytics-modal',
  templateUrl: './analytics-modal.component.html',
  styleUrls: ['./analytics-modal.component.css']
})
export class AnalyticsModalComponent implements OnInit {
  deviceanalytics: any;
  deviceOs: Boolean;
  deviceBrowser: Boolean;
  deviceScreen: Boolean;
  canvasgauserOs: any;
  ctxgauserOs: any;
  myChartgauserOs: any;
  colors = [
       'rgba(26,187,156)',
    'rgba(2,66,128)',
    'rgba(100,118,137)',
    'rgba(252,106,89)',
    'rgba(69,39,160)',
    'rgba(219,211,189)',
    "rgb( 127,96,0)",
    "rgb( 19,79,92)",
    "rgb(153,153,153)",
    "rgb(102, 224, 224)",

    "rgb(224,102,221)",
    "rgb(246,178,117)",
    "rgb(147,196,200)",
    "rgb(189,165,121)",
    "rgb(111,168,110)",
    "rgb(142,124,171)",
    "rgb(194,123,167)",
    "rgb( 127,96,6)",
    "rgb( 19,79,192)",
    "rgb(153,153,103)",
    "rgb(102, 224, 114)",

    "rgb(224,233,102)",
    "rgb(246,112,107)",
    "rgb(147,123,125)",
    "rgb(189,234,175)",
    "rgb(111,112,220)",
    "rgb(142,98,195)",
    "rgb(194,34,160)",
    "rgb( 127,134,0)",
    "rgb( 19,143,92)",
    "rgb(153,112,153)",
    "rgb(102, 117, 224)"
   
    ];
    piedataOs: any;
    piedataBrowser: any;
    piedataScreen: any;
  canvasgauserScreen: any;
  ctxgauserScreen: any;
  myChartgauserScreen: any;
  canvasgauserBrowsers: any;
  ctxgauserBrowsers: any;
  myChartgauserBrowsers: any;
  deviceCategory: any;
  constructor(private dialogRef: MatDialogRef<AnalyticsModalComponent>,	
     	@Inject(MAT_DIALOG_DATA) public data: String) { }

  ngOnInit() {
    console.log('---------GADATA--------',this.data)
    this.deviceanalytics = this.data;
    this.piedataOs = this.deviceanalytics.tabledata;
    this.deviceCategory =this.deviceanalytics.devicetype;

    if(this.deviceanalytics.devicetype === "title1" ){
     this.deviceOs = true;
     
    }else if(this.deviceanalytics.devicetype === "title2"){
      this.deviceBrowser = true;
      this.deviceCategory === "title2"
    }else if(this.deviceanalytics.devicetype === "title3"){
      this.deviceScreen = true;
      this.deviceCategory === "title3"
    }
  }
  ngAfterViewInit() {
    this.createOschart();
    this.updateChartgaUserOs(this.myChartgauserOs); 
    this.createBrowserchart();
    this.updateChartgaUserBrowsers(this.myChartgauserBrowsers); 
    this.createScreenchart();
    this.updateChartgaUserScreen(this.myChartgauserScreen); 
    

}
  
  createOschart(){
    Chart.defaults.global.defaultFontColor = "#000";
    this.canvasgauserOs = document.getElementById("myChartgauserOs1");
    if (this.canvasgauserOs !== null) {
    this.ctxgauserOs = this.canvasgauserOs.getContext("2d");
    this.myChartgauserOs = new Chart(this.ctxgauserOs, {
      type: "pie",
      data: {
        labels: [],
        datasets: [
          {
            label: "# of Votes",
            data: [],
            backgroundColor: [],
            borderWidth: 1,
            pointStyle: 'circle'
            
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: 'Operating System',
          fontColor: "#5f7388",
          fontSize: 16
      },
        responsive: true,
        display: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            fontSize:9,
         }
       },
      }
    });
  }
}
createBrowserchart(){
  Chart.defaults.global.defaultFontColor = "#000";
   this.canvasgauserBrowsers = document.getElementById("myChartgauserBrowsers1");
    if (this.canvasgauserBrowsers !== null) {
    this.ctxgauserBrowsers = this.canvasgauserBrowsers.getContext("2d");
    this.myChartgauserBrowsers = new Chart(this.ctxgauserBrowsers, {
      type: "pie",
      data: {
        labels: [],
        
        datasets: [
          {
            label: "# of Votes",
            data: [],
            backgroundColor: [],
            borderWidth: 1,
            pointStyle: 'circle'
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: 'Browser',
          fontColor: "#5f7388",
          fontSize: 16
      },
        responsive: true,
        display: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            fontSize:9,
         }
       },
      }
    });
  }

}
createScreenchart(){
  Chart.defaults.global.defaultFontColor = "#000";
  this.canvasgauserScreen = document.getElementById("myChartgauserScreen1");
    if (this.canvasgauserScreen !== null) {
    this.ctxgauserScreen = this.canvasgauserScreen.getContext("2d");
    this.myChartgauserScreen = new Chart(this.ctxgauserScreen, {
      type: "pie",
      data: {
        labels: [],
        datasets: [
          {
            label: "# of Votes",
            data: [],
            backgroundColor: [],
            borderWidth: 1,
            pointStyle: 'circle'
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: 'Screen Resolution',
          fontColor: "#5f7388",
          fontSize: 16
      },
        responsive: true,
        display: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            fontSize:9,
         }
       },
      }
    });
  }
}
updateChartgaUserOs(myChartgauserOs1) {
  console.log("-------data=====",this.piedataOs)
  for (let i = 0; i < this.piedataOs.length; i++) {
    myChartgauserOs1.data.labels.push(this.piedataOs[i].os);
    myChartgauserOs1.data.datasets[0].data.push(this.piedataOs[i].user_percent);
    myChartgauserOs1.data.datasets[0].backgroundColor.push(this.getColor(i));

  }
  myChartgauserOs1.update();
}
updateChartgaUserBrowsers(myChartgauserBrowsers1) {
  for (let i = 0; i < this.piedataOs.length; i++) {
    myChartgauserBrowsers1.data.labels.push(this.piedataOs[i].browser);
    myChartgauserBrowsers1.data.datasets[0].data.push(this.piedataOs[i].user_percent);
    myChartgauserBrowsers1.data.datasets[0].backgroundColor.push(this.getColor(i));

  }
  myChartgauserBrowsers1.update();
}
updateChartgaUserScreen(myChartgauserScreen1) {
  for (let i = 0; i < this.piedataOs.length; i++) {
    myChartgauserScreen1.data.labels.push(this.piedataOs[i].resolution);
    myChartgauserScreen1.data.datasets[0].data.push(this.piedataOs[i].user_percent);
      myChartgauserScreen1.data.datasets[0].backgroundColor.push(this.getColor(i));

  }
  myChartgauserScreen1.update();
}
getRandomColor() {
  let letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 50; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}
getColor(num) {
  if (num < 50) {
    return this.colors[num];
  } else {
    this.getRandomColor();
  }
}
}



// WEBPACK FOOTER //
// ./src/app/_models/analytics-modal/analytics-modal.component.ts